// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;Then shall my enemies turn back<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;on the day when I call upon you;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;this I know, for God is on my side.<br> </p> </div></div>";
// Exports
module.exports = code;